import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-203">
      <div className="max-w-4xl mx-auto text-center" data-id="element-204">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3" data-id="element-205">
          <span className="text-4xl" data-id="element-206">🎨</span> EDULABS™ Italia
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-207">
          Risorse d'eccellenza per la Scuola Primaria.
        </p>
        <p className="text-white/70 text-sm italic mb-10" data-id="element-208">
          Perché insegnare matematica non dovrebbe toglierti i tuoi momenti di
          relax.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-209">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-210">
            <span data-id="element-211">📧</span> supporto.edulabs@gmail.com
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-212">
            <span data-id="element-213">📲</span> @edulabs.italia
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-214">
            <span data-id="element-215">🌐</span> www.artepronta.it
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-216" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-217">
          © EDULABS™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}